import { render, staticRenderFns } from "./FormulateMultiselect.vue?vue&type=template&id=37ce4835&"
import script from "./FormulateMultiselect.vue?vue&type=script&lang=ts&"
export * from "./FormulateMultiselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports